export const ApiMethods = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
}

export const REGISTER = "registration"
export const PATIENTINFO = "patient"
export const SCHEDULE = "schedule"
export const INVOICE = "invoice"
export const NEW = "New"
export const REVIEW = "Review"
export const SURGERY = "Surgery"
export const MEETING = "Meeting"
export const BREAK = "Break"

export const ERROR_MESSAGE = "OOPS something went wrong"

export const allFeaturesRoles = ["ADMIN", "STAFF"]

export const NoSearchResults = "No Search Results"
export const EmptyData = "Empty Data"

export const CONSULTANT = "Consultant"
export const GENERAL_PHYSICIAN = "General Physician"
export const GP = "GP"
export const OPTOMETRIST = "Optometrist"
export const ORTHOPHIST = "Orthoptist"
export const OTHER = "Other"

export const roleOptions = [
  // { label: "Doctor", value: "Doctor" },
  { label: CONSULTANT, value: CONSULTANT },
  { label: "Staff", value: "Staff" },
  { label: "General Physician", value: "GP" },
  { label: "Optometrist", value: "Optometrist" },
  { label: ORTHOPHIST, value: ORTHOPHIST },
]

export const relationShipOptions = [
  { label: "Father", value: "Father" },
  { label: "Mother", value: "Mother" },
  { label: "Spouse", value: "Spouse" },
  { label: "Sibling", value: "Sibling" },
  { label: "Gaurdian", value: "Gaurdian" },
  { label: "Friend", value: "Friend" },
  { label: OTHER, value: OTHER },
]

export const patientTableKeys = ["Patient ID", "Patient Name", "Date of Birth"]
export const docterTableKeys = ["Name", "Role"]
export const invoiceTableKeys = ["Patient Name", "Patient ID", "Invoice Amount"]

export const allLabelData = {
  _id: "All",
  label: "All",
  value: { _id: "All", label: "All" },
}
export const allLabelOption = { All: allLabelData }
export const DDMMYYYY = "DD-MM-YYYY"
export const DDMMYYYY_SLASH = "DD/MM/YYYY"
export const ALL = "All"
export const COMPLETED = "Completed"
export const ON_GOING = "On going"
export const UP_COMING = "Upcoming"
export const CANCEL = "Cancel"
export const CANCELLED = "Cancelled"

export const sideBarStatusOptions = [ALL, COMPLETED, ON_GOING, UP_COMING, CANCEL]

export const statusCodes = {
  success: "Success",
}

export const commonDateFormat = "DD/MM/YYYY"
export const commonTimeFormat = "hh:mm A"

export const commonDateTimeFormat = `${commonDateFormat} ${commonTimeFormat}`

export const patientInfoSearch = "Search by Name or ID or Date"
export const invoiceInfoSearch = "Search by Name or ID"
export const PROFILE = "Profile"
export const SETTINGS = "Settings"

export const CLINICS = "Clinics"
export const OPERATION_THEATRE = "Operation Theatre"

export const tableInitialDataCount = 20

export const EDIT_APPOINTMENT = "Edit Appointment"
export const CREATE_APPOINTMENT = "Create Appointment"

export const RIGHT_EYE = "Right Eye"
export const LEFT_EYE = "Left Eye"
export const BOTH_EYES = "Both Eyes"
export const surgeryTypeOptions = [
  { label: RIGHT_EYE, value: RIGHT_EYE },
  { label: LEFT_EYE, value: LEFT_EYE },
  { label: BOTH_EYES, value: BOTH_EYES }
]

export const PENDING = "Pending"
export const PAID = "Paid"
export const INSURANCE = "Insurance"
export const paymentStatusOptions = [
  { label: PENDING, value: PENDING },
  { label: PAID, value: PAID },
  { label: INSURANCE, value: INSURANCE }
]

export const ROOM_1 = "Room 1"
export const ROOM_2 = "Room 2"

export const roomOptions = [
  { label: ROOM_1, value: ROOM_1 },
  { label: ROOM_2, value: ROOM_2 },
]